export default __webpack_public_path__ + "static/media/1.45bb153c.png";